import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';

import {
  TabGroup,
  TabLabel,
  TabList,
  TabPanel,
  TabPanels,
} from '@/components/Tabs/Tabs';
import { PermissionsEnum, usePermissions } from '@/hooks/usePermissions';
import { useOrganizationId } from '@/hooks/useSwr';
import { appOrganizationPath } from '@/utils/constants';

const tabs = [
  {
    id: 'members',
    displayName: 'Members',
  },
  {
    id: 'apikeys',
    displayName: 'API Keys',
  },
  {
    id: 'resource_tags',
    displayName: 'Resource Tags',
    permission: 'workspaces:manage',
  },
  {
    id: 'models',
    displayName: 'Model pricing',
  },
  {
    id: 'shared',
    displayName: 'Shared',
  },
  {
    id: 'secrets',
    displayName: 'Secrets',
  },
  {
    id: 'feedbacks',
    displayName: 'Feedbacks',
  },
];
const WorkspaceSettings = () => {
  const { workspaceSetting } = useParams();
  const workspaceId = useOrganizationId();
  const navigate = useNavigate();
  useEffect(() => {
    if (!workspaceSetting) {
      navigate(
        `/${appOrganizationPath}/${workspaceId}/settings/workspaces/members`
      );
    }
  }, []);

  const { authorize } = usePermissions('workspace');
  const accessibleTabs = tabs.filter((tab) =>
    tab.permission ? authorize(tab.permission as PermissionsEnum) : true
  );

  return (
    <TabGroup
      setTabMethod="routeParam"
      routeParamName="workspaceSetting"
      tabIds={accessibleTabs.map((t) => t.id)}
    >
      <TabList className="relative mx-0 mb-0 overflow-x-auto pl-0">
        {accessibleTabs.map((t) => (
          <TabLabel className="capitalize" key={t.id}>
            {t.displayName}
          </TabLabel>
        ))}
      </TabList>

      <TabPanels className="flex flex-1 flex-col overflow-hidden">
        {accessibleTabs.map((tab) => (
          <TabPanel
            className="flex flex-1 flex-col overflow-hidden py-4 pt-0"
            key={tab.id}
          >
            <div className="w-full overflow-auto py-4">
              <Outlet />
            </div>
          </TabPanel>
        ))}
      </TabPanels>
    </TabGroup>
  );
};
export { WorkspaceSettings };
